<template>
    <v-container fluid class="pa-0">
        <v-row column justify-center align-center>
            <v-col cols="12" class="py-0">
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <!-- <ValidationObserver ref="observer" v-slot="{ invalid }"> -->
                    <v-form
                        id="ebookForm"
                        ref="ebookForm"
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        name="ebookForm"
                        action="/ebook/"
                        method="POST"
                        @submit.prevent="handleSubmit(handleSubmission)"
                    >
                        <!-- @submit.prevent="handleSubmit(handleSubmission)" -->
                        <input
                            id="form-name"
                            type="hidden"
                            name="form-name"
                            value="ebookForm"
                        />
                        <v-container class="ebookForm--wrapper">
                            <!-- <v-row>
                                <pre>{{ sampleOptions }}</pre>
                            </v-row> -->
                            <v-row column justify-center align-center>
                                <!-- <v-col cols="6">
                                    <v-switch
                                        v-model="requestDownload"
                                        class="mx-2"
                                        color="success"
                                        label="Download eBook"
                                    ></v-switch>
                                </v-col> -->
                                <v-col cols="12" md="6" class="pt-0 pl-0">
                                    <!-- FIRST NAME -->
                                    <ValidationProvider
                                        name="firstname"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="firstname"
                                                v-model="firstname"
                                                name="firstname"
                                                :label="localize('firstName')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="lastname"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="lastname"
                                                v-model="lastname"
                                                name="lastname"
                                                :label="localize('lastName')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="company"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="company"
                                                v-model="company"
                                                name="company"
                                                :label="localize('company')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="company_zip"
                                        :rules="{
                                            required: true,
                                            numeric: true,
                                        }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="company_zip"
                                                v-model="company_zip"
                                                name="company_zip"
                                                :label="`${localize(
                                                    'company'
                                                )} ${localize(
                                                    'zipPostalCode'
                                                )}`"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="email"
                                        rules="required|email|emoji"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="email"
                                                v-model="email"
                                                name="email"
                                                :label="localize('email')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="phone"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="phone"
                                                v-model="phone"
                                                v-mask="phoneMask"
                                                name="phone"
                                                :label="localize('phone')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="jobtitle"
                                        rules=""
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="jobtitle"
                                                v-model="jobtitle"
                                                name="jobtitle"
                                                :label="localize('jobTitle')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="do_you_build_your_own_control_panels_"
                                        rules=""
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">{{
                                                errors[0]
                                            }}</span>
                                            <v-select
                                                id="do_you_build_your_own_control_panels_"
                                                v-model="
                                                    do_you_build_your_own_control_panels_
                                                "
                                                :items="[
                                                    {
                                                        label: localize('yes'),
                                                        value: 'Yes',
                                                    },
                                                    {
                                                        label: localize('no'),
                                                        value: 'No',
                                                    },
                                                ]"
                                                name="do_you_build_your_own_control_panels_"
                                                item-text="label"
                                                item-value="value"
                                                outlined
                                                dense
                                                :hide-details="true"
                                                :label="
                                                    localize(
                                                        'doYouBuildYourOwnControlPanels'
                                                    )
                                                "
                                            ></v-select>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" class="pt-0 pl-0">
                                    <h2>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'bonusOfferFreeMCBSample',
                                            }"
                                        />
                                    </h2>
                                    <p>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'pleaseFillOutTheInformationBelowSoWeCanGetYouASample',
                                            }"
                                        />
                                    </p>
                                </v-col>
                                <v-col cols="12" class="pt-0 pl-0">
                                    <v-switch
                                        v-model="requestSample"
                                        class="mx-2"
                                        color="success"
                                        :label="localize('requestMCBSample')"
                                    ></v-switch>
                                </v-col>
                                <v-col
                                    v-show="requestSample"
                                    cols="12"
                                    md="12"
                                    class="pt-0 pl-0"
                                >
                                    <ValidationProvider
                                        name="samples_requested"
                                        :rules="{ required: requestSample }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">{{
                                                errors[0]
                                            }}</span>
                                            <v-select
                                                id="samples_requested"
                                                v-model="samples_requested"
                                                :items="sampleOptions"
                                                name="samples_requested"
                                                item-text="label"
                                                item-value="value"
                                                outlined
                                                dense
                                                :hide-details="true"
                                                :label="
                                                    localize(
                                                        'selectYourMCBSample'
                                                    )
                                                "
                                            ></v-select>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    v-show="requestSample"
                                    cols="12"
                                    md="12"
                                    class="pt-0 pl-0"
                                >
                                    <ValidationProvider
                                        name="address"
                                        :rules="{ required: requestSample }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="address"
                                                v-model="address"
                                                name="address"
                                                :label="localize('address1')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    v-show="requestSample"
                                    cols="12"
                                    md="12"
                                    class="pt-0 pl-0"
                                >
                                    <ValidationProvider
                                        name="street_address_2"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="street_address_2"
                                                v-model="street_address_2"
                                                name="street_address_2"
                                                :label="
                                                    localize(
                                                        'streetAddress2Optional'
                                                    )
                                                "
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    v-show="requestSample"
                                    cols="12"
                                    md="12"
                                    class="pt-0 pl-0"
                                >
                                    <ValidationProvider
                                        name="city"
                                        :rules="{ required: requestSample }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="city"
                                                v-model="city"
                                                name="city"
                                                :label="localize('cityTown')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    v-show="requestSample"
                                    cols="12"
                                    md="6"
                                    class="pt-0 pl-0"
                                >
                                    <ValidationProvider
                                        name="state"
                                        :rules="{ required: requestSample }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="state"
                                                v-model="state"
                                                name="state"
                                                :label="
                                                    localize('stateProvince')
                                                "
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    v-show="requestSample"
                                    cols="12"
                                    md="6"
                                    class="pt-0 pl-0"
                                >
                                    <ValidationProvider
                                        name="zip"
                                        :rules="{
                                            required: requestSample,
                                            numeric: true,
                                        }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="zip"
                                                v-model="zip"
                                                name="zip"
                                                :label="
                                                    localize('zipPostalCose')
                                                "
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" class="pt-0 pl-0">
                                    <recaptcha
                                        @success="onSuccess"
                                        @error="onError"
                                        @expired="onExpired"
                                    />
                                    <div
                                        v-if="captchaError"
                                        class="captcha-error"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'captchaRequired',
                                            }"
                                        />
                                    </div>
                                </v-col>
                                <v-col cols="12" md="12" class="pt-0 pl-0">
                                    <ValidationProvider
                                        name="subscribe_to_our_enewsletter"
                                        rules=""
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-checkbox
                                                v-model="
                                                    subscribe_to_our_enewsletter
                                                "
                                                name="subscribe_to_our_enewsletter"
                                            >
                                                <template v-slot:label>
                                                    <div>
                                                        <span>
                                                            <TranslatableStringComponent
                                                                :tstring="{
                                                                    string:
                                                                        'subscribeToOurENewsletter',
                                                                }"
                                                            />
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    v-show="!okToDownload"
                                    cols="12"
                                    class="pt-0 pl-0"
                                >
                                    <v-btn
                                        type="submit"
                                        color="primary"
                                        :loading="loader"
                                        right
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: `${requestButtonText}`,
                                            }"
                                        />
                                    </v-btn>
                                </v-col>
                                <v-col v-show="okToDownload" cols="12">
                                    <v-btn
                                        :href="downloadURL"
                                        target="_blank"
                                        color="warning"
                                        right
                                        ><TranslatableStringComponent
                                            :tstring="{
                                                string: 'openEBookAgain',
                                            }"
                                    /></v-btn>
                                </v-col>
                                <v-col cols="12">
                                    <div v-if="sending">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'submittingContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="waiting">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'awaitingContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="success">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'successfulContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="failure">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'failedContactForm',
                                            }"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </ValidationObserver>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { createHelpers } from 'vuex-map-fields'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapGetters, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import Cookies from 'js-cookie'
import { gtmEvent } from '~/plugins/global'
import encodeFormData from '~/mixins/encodeFormData'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import downloadFile from '~/util/downloadFile'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
const { mapFields } = createHelpers({
    getterType: 'getEbookField',
    mutationType: 'updateEbookField',
})

export default {
    name: 'FormEbookDownload',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
    },
    directives: {
        mask,
    },
    mixins: [encodeFormData, handleRecaptcha],
    data() {
        return {
            downloadURL:
                'https://bt.e-ditionsbyfry.com/publication/?m=34013&i=664158&p=1&pre=1',
            hints: {
                email: '',
                password: '',
            },
            sending: false,
            waiting: false,
            success: false,
            failure: false,
            requestDownload: true,
            requestSample: false,
            loader: false,
            okToDownload: false,
            phoneMask: '(###) ###-####',
        }
    },
    computed: {
        // ...mapState('formSelectOptions', ['jobRoles']),
        sampleOptions() {
            const mcbs =
                this.sampleCategory && this.sampleCategory.length > 0
                    ? this.sampleCategory.filter((item) => {
                          return item.label.en === 'Miniature Circuit Breaker'
                      })
                    : []
            const options =
                mcbs && mcbs.length > 0
                    ? this.productsAsPerCategory(mcbs[0]._id)
                          .sort((a, b) =>
                              a.description.en > b.description.en ? 1 : -1
                          )
                          .map((item) => {
                              return {
                                  label: `${item.title.en} | ${item.description.en}`,
                                  value: item.title.en,
                              }
                          })
                    : []
            // options.sort((a, b) =>
            //     a.description &&
            //     a.description.en &&
            //     b.description &&
            //     b.description.en &&
            //     a.description.en > b.description.en
            //         ? 1
            //         : -1
            // )
            return options
        },
        ...mapState('sampleReferenceTable', ['selectedSamples']),
        ...mapFields('ebook', [
            'firstname',
            'lastname',
            'company',
            'email',
            'phone',
            'jobtitle',
            'address',
            'street_address_2',
            'city',
            'state',
            'zip',
            'company_zip',
            'samples_requested',
            'do_you_build_your_own_control_panels_',
            'subscribe_to_our_enewsletter',
        ]),
        requestButtonText() {
            if (this.requestDownload && this.requestSample) {
                return 'requestDownloadAndSample'
            } else {
                return 'requestDownloadEbook'
            }
        },
        ...mapGetters({
            sampleCategory: 'sampleReferenceTable/sampleCategory',
            sampleProduct: 'sampleReferenceTable/sampleProduct',
            selectedSampleProducts:
                'sampleReferenceTable/selectedSampleProducts',
        }),
        selectedButtons: {
            get() {
                return this.$store.state.sampleReferenceTable.selectedButtons
            },
            set(v) {
                this.$store.commit(
                    'sampleReferenceTable/updateSelectedButtons',
                    v
                )
            },
        },
        selectedSampleProductsNames() {
            return this.selectedSampleProducts.map((item) => item.title.en)
        },
    },
    mounted() {
        this.fetchSamples()
    },
    methods: {
        fetchSamples() {
            this.$store.dispatch('sampleReferenceTable/fetchSamples')
        },
        productsAsPerCategory(catId) {
            return this.sampleProduct.filter((item) => {
                return item.categories.some((c) => {
                    return c._id === catId
                })
            })
        },
        addSample(product) {
            this.$store.dispatch('sampleReferenceTable/addSample', product)
        },
        handleSubmission() {
            if (!this.token) {
                this.captchaError = true
                return
            }
            this.sending = true
            this.waiting = false
            this.success = false
            this.failure = false
            this.loader = true
            const hubspotutk = Cookies.get('hubspotutk') || 0
            const axiosConfig = {
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }

            this.$axios
                .post('reCaptcha-server-side-validation', {
                    token: this.token,
                })
                .then((res) => {
                    // console.log('RECAPTCHA RESPONSE:', res)
                    if (res.data && res.data.success === false) throw res.data

                    this.$axios
                        .post(
                            process.env.V2_BASE_URL + '/ebook/',
                            this.encode({
                                'form-name': 'ebookForm',
                                // 'name.first': this.firstname,
                                // 'name.last': this.lastname,
                                // 'email': this.email,
                                // 'PhoneNumber.number': this.phone,
                                // 'customData.jobTitle': this.jobtitle,
                                // 'name.company': this.company,
                                // 'MailAddress.line1': this.address,
                                // 'MailAddress.line2': this.street_address_2,
                                // 'MailAddress.city': this.city,
                                // 'MailAddress.state': this.state,
                                // 'MailAddress.postalCode': this.zip,
                                // 'customData.companyZip': this.company_zip,
                                // 'customData.lastSamplesRequested': this.samples_requested,
                                // 'customData.companyBuildsOwnControlPanels': this.do_you_build_your_own_control_panels_,
                                // 'customData.isSubscribedToNewsletter': this.subscribe_to_our_enewsletter,
                                ...this.$store.state.ebook.ebookForm,
                                hubspotutk,
                            }),
                            axiosConfig
                        )
                        .then((res) => {
                            // console.log('full response', res)
                            this.sending = false
                            this.waiting = true
                            this.$axios
                                .post(
                                    'submitted-web-form',
                                    res.config.data,
                                    axiosConfig
                                )
                                .then((response) => {
                                    gtmEvent({
                                        gtm: this.$gtm,
                                        event: 'ebookForm',
                                        eventType: 'form',
                                        atts: {
                                            ...this.$store.state.ebook
                                                .ebookForm,
                                        },
                                    })
                                    this.resetForm('ebookForm')
                                    this.$recaptcha.reset()
                                    // console.log('This was a success on the frontend')
                                    this.loader = false
                                    this.waiting = false
                                    this.success = true
                                    this.okToDownload = true
                                    downloadFile(this.downloadURL, '')
                                })
                                .catch((error) => {
                                    console.log('lambda failure was', error)
                                    this.handleErrors()
                                })
                        })
                        .catch((err) => {
                            console.log(
                                'This form submission failed at Netlify for some reason. Please try again. ERROR',
                                err
                            )
                            this.handleErrors()
                        })
                })
                .catch((err) => {
                    console.log(
                        'Google recaptcha validation failed for some reason. Please try again. ERROR',
                        err
                    )
                    this.handleErrors()
                })
        },
        handleErrors() {
            this.$recaptcha.reset()
            this.loader = false
            this.sending = false
            this.waiting = false
            this.failure = true
        },
    },
}
</script>
